"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WordBreakdownWrapper = function WordBreakdownWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "selectedCharacters", _descriptor, _this);
      _initializerDefineProperty(_this, "editMode", _descriptor2, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "clearUnderlinedCharacters",
      value: function clearUnderlinedCharacters() {
        this.selectedCharacters = [];
        this.submit();
      }
    }, {
      key: "toggleEditMode",
      value: function toggleEditMode() {
        var _this$props$card, _this$props$word;
        this.editMode = !this.editMode;
        if (!this.editMode && (this.selectedCharacters.join(',') !== ((_this$props$card = this.props.card) === null || _this$props$card === void 0 ? void 0 : _this$props$card.underlinedCharacters) || this.selectedCharacters.join(',') !== ((_this$props$word = this.props.word) === null || _this$props$word === void 0 ? void 0 : _this$props$word.stressedCharacters))) {
          this.submit();
        } else {
          this.selectedCharacters = [];
        }
      }
    }, {
      key: "onClickOnCharacter",
      value: function onClickOnCharacter(index) {
        if (this.editMode) {
          var _this$selectedCharact;
          var indexInUnderlinedCharacters = (_this$selectedCharact = this.selectedCharacters) === null || _this$selectedCharact === void 0 ? void 0 : _this$selectedCharact.indexOf(index);
          if (indexInUnderlinedCharacters === -1) {
            this.selectedCharacters.push(index);
          } else {
            this.selectedCharacters.splice(indexInUnderlinedCharacters, 1);
          }
        }
      }
    }, {
      key: "submit",
      value: function submit() {
        if (this.props.card) {
          _state.DeckUI.cardStore.update({
            ids: {
              cardId: this.props.card.id
            },
            data: {
              underlinedCharacters: this.selectedCharacters.join(',')
            }
          }, this.props.afterChange);
        } else if (this.props.word) {
          _stores.WordStore.update({
            ids: {
              wordId: this.props.word.id
            },
            data: {
              stressedCharacters: this.selectedCharacters.join(',')
            }
          }, this.props.afterChange);
        }
      }
    }, {
      key: "charIsSelected",
      value: function charIsSelected(index) {
        if (this.props.card) {
          var _this$props$card$unde;
          return !(0, _utils.isBlank)(this.props.card.underlinedCharacters) && ((_this$props$card$unde = this.props.card.underlinedCharacters.split(',')) === null || _this$props$card$unde === void 0 ? void 0 : _this$props$card$unde.includes(index.toString()));
        }
        if (this.props.word) {
          var _this$props$word$stre;
          return !(0, _utils.isBlank)(this.props.word.stressedCharacters) && ((_this$props$word$stre = this.props.word.stressedCharacters.split(',')) === null || _this$props$word$stre === void 0 ? void 0 : _this$props$word$stre.includes(index.toString()));
        }
      }
    }, {
      key: "underlinedCharacters",
      get: function get() {
        if (this.props.card) {
          return this.props.card.underlinedCharacters;
        }
        if (this.props.word) {
          return this.props.word.stressedCharacters;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          selectedCharacters: this.selectedCharacters,
          onClick: this.onClickOnCharacter,
          editMode: this.editMode,
          toggleEditMode: this.toggleEditMode,
          clearUnderlinedCharacters: this.clearUnderlinedCharacters,
          charIsSelected: this.charIsSelected,
          underlinedCharacters: this.underlinedCharacters
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectedCharacters", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "editMode", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "clearUnderlinedCharacters", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearUnderlinedCharacters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleEditMode", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleEditMode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickOnCharacter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickOnCharacter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "submit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "submit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "charIsSelected", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "charIsSelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "underlinedCharacters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "underlinedCharacters"), _class2.prototype), _class2)) || _class;
};
WordBreakdownWrapper.displayName = 'WordBreakdownWrapper';
var _default = exports["default"] = WordBreakdownWrapper;